import { connect } from 'react-redux';
import { selectAmount } from 'redux/reload/reload.actions';
import CustomAmountPad from './CustomAmountPad.component';

const mapDispatchToProps = {
  onChange: selectAmount,
};

export default connect(undefined, mapDispatchToProps)(CustomAmountPad);
